$().ready(function () {

$('#addshed').click(function(){
  var qty = $('#holdqty').val();
  window.location.href = 'https://www.ibran.com/cart/43016076853430:'+qty;
})
  
  var lgt = $("#lng").val(),
    wdt = $("#wdth").val();

  calca(lgt, wdt);

  $(".qrange").on("input", function () {
    var lgt = $("#lng").val(),
      wdt = $("#wdth").val();
    calca(lgt, wdt);
  });
});

function calca(l, w) {
  var sqft = l * w;
  console.log(sqft),
    (lgtt = roundhalf(0.3048 * l)),
    (wdtt = roundhalf(0.3048 * w));

  $("#lgt").html(l + "ft (" + lgtt + "m)");
  $("#wdt").html(w + "ft (" + wdtt + "m)");
  var qtyr = 4 * lgtt * wdtt;
  $("#quantity").val(qtyr);
  var pro = qtyr * 3.00;
  $("#qtr").html("&pound;" + pro.toFixed(2) + " inc. VAT");
  $('#holdqty').val(qtyr);
  $('#Quantity-quantity_block_H9KAT6').val(qtyr);
}
function roundhalf(n) {
  return (Math.ceil(n * 2) / 2).toFixed(2);
}
